module.exports = __webpack_public_path__ + "static/media/periodic-table-lager.591dc74c.png";